import { TrafficType } from '../../types/TrafficType'

export const getTrafficType = (isPro: boolean): TrafficType =>
	isPro ? TrafficType.EXTERNAL : TrafficType.INTERNAL
